import React, { useState } from "react";
import { Alert, Button, Stack } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function PendingPromoAlert() {
  const {
    authorizationError,
    clearAuthorizationError,
    isAuthenticated,
    retryPendingRegistrationPromo,
  } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [retrying, setRetrying] = useState(false);

  if (!isAuthenticated || !authorizationError || location.pathname === "/licencias") {
    return null;
  }

  const retry = async () => {
    setRetrying(true);
    try {
      await retryPendingRegistrationPromo();
    } catch {
      // Keep the alert available for another attempt.
    } finally {
      setRetrying(false);
    }
  };

  return (
    <Alert
      severity="error"
      action={
        <Stack direction="row" spacing={0.5}>
          <Button color="inherit" size="small" onClick={retry} disabled={retrying}>
            {retrying ? "Reintentando…" : "Reintentar"}
          </Button>
          <Button color="inherit" size="small" onClick={() => navigate("/licencias")}>
            Ver licencias
          </Button>
          <Button color="inherit" size="small" onClick={clearAuthorizationError}>
            Descartar
          </Button>
        </Stack>
      }
      sx={{ borderRadius: 0, alignItems: "center" }}
    >
      No hemos podido activar tu beneficio promocional. Reinténtalo o revisa tus licencias.
    </Alert>
  );
}
